import api from 'infra/config/api';

export default function favoriteBookService(bookId) {
    const url = '/favorite-book.php';
    return api
    .url(url)
    .post({ bookId })
    .text();
}